import { createSvgIcon } from '@mui/material';
import { styled } from '@mui/material';

export const SettingsFallbackIcon = createSvgIcon(
	<svg
		width='174'
		height='109'
		viewBox='0 0 174 109'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'>
		<path
			opacity='0.1'
			d='M47.4104 39.5002L53.7612 35.8335C57.514 33.6668 63.6844 33.646 67.4733 35.8335C74.0046 39.6043 81.2936 38.4793 83.6752 33.3127C85.0464 30.3543 90.3869 28.5627 95.547 29.3752L105.362 30.9168C109.909 31.5835 112.579 34.2918 111.424 36.9168L111.135 37.5418C108.718 42.6877 114.058 45.771 123.007 44.396L124.09 44.2293C128.636 43.5627 133.327 45.1043 134.482 47.7293L137.152 53.396C138.56 56.3752 135.456 59.4585 130.332 60.2501C121.383 61.6252 119.435 65.8335 125.966 69.6043C129.719 71.771 129.755 75.3335 125.966 77.521L119.615 81.1877C115.862 83.3543 109.692 83.3752 105.903 81.1877C99.3719 77.4168 92.0829 78.5418 89.7013 83.7085C88.294 86.6877 82.9896 88.4585 77.8295 87.646L68.0146 86.1043C63.4679 85.4377 60.7977 82.7293 61.9524 80.1043L62.2411 79.4793C64.6587 74.3335 59.3182 71.2502 50.3693 72.6252L49.2868 72.7918C44.7401 73.4585 40.0492 71.9168 38.8945 69.2918L36.2242 63.6252C34.8169 60.646 37.9202 57.5627 43.0442 56.771C51.9931 55.396 53.9417 51.1877 47.4104 47.4168C43.6215 45.2293 43.6576 41.6668 47.4104 39.5002Z'
			fill='currentColor'
		/>
		<path
			opacity='0.1'
			d='M74.9425 65.271C81.4194 69.0104 91.9205 69.0104 98.3973 65.271C104.874 61.5316 104.874 55.4688 98.3974 51.7293C91.9205 47.9899 81.4194 47.9899 74.9425 51.7293C68.4656 55.4688 68.4656 61.5316 74.9425 65.271Z'
			fill='currentColor'
		/>
		<path
			opacity='0.4'
			d='M75.8446 56.75C81.8233 60.2018 91.5166 60.2018 97.4952 56.75C103.474 53.2982 103.474 47.7018 97.4952 44.25C91.5166 40.7982 81.8233 40.7982 75.8446 44.25C69.8659 47.7018 69.8659 53.2982 75.8446 56.75Z'
			stroke='currentColor'
			stroke-width='1.5'
			stroke-miterlimit='10'
			stroke-linecap='round'
			stroke-linejoin='round'
		/>
		<path
			d='M47.4104 31.5002L53.7612 27.8335C57.514 25.6668 63.6844 25.646 67.4733 27.8335C74.0046 31.6043 81.2936 30.4793 83.6752 25.3127C85.0464 22.3543 90.3869 20.5627 95.547 21.3752L105.362 22.9168C109.909 23.5835 112.579 26.2918 111.424 28.9168L111.135 29.5418C108.718 34.6877 114.058 37.771 123.007 36.396L124.09 36.2293C128.636 35.5627 133.327 37.1043 134.482 39.7293L137.152 45.396C138.56 48.3752 135.456 51.4585 130.332 52.2502C121.383 53.6252 119.435 57.8335 125.966 61.6043C129.719 63.771 129.755 67.3335 125.966 69.521L119.615 73.1877C115.862 75.3543 109.692 75.3752 105.903 73.1877C99.3719 69.4168 92.0829 70.5418 89.7013 75.7085C88.294 78.6876 82.9896 80.4585 77.8295 79.646L68.0146 78.1043C63.4679 77.4377 60.7977 74.7293 61.9524 72.1043L62.2411 71.4793C64.6587 66.3335 59.3182 63.2502 50.3693 64.6252L49.2868 64.7918C44.7401 65.4585 40.0492 63.9168 38.8945 61.2918L36.2242 55.6252C34.8169 52.646 37.9202 49.5627 43.0442 48.771C51.9931 47.396 53.9417 43.1877 47.4104 39.4168C43.6215 37.2293 43.6576 33.6668 47.4104 31.5002Z'
			stroke='currentColor'
			stroke-width='1.5'
			stroke-miterlimit='10'
			stroke-linecap='round'
			stroke-linejoin='round'
		/>
	</svg>,
	'SettingsFallbackIcon'
);

export const SettingsFallback = styled(SettingsFallbackIcon)((props) => ({
	fill: '#fff0',
	...(props.width && {
		width: props.width,
		height: props.width
	})
}));

export default SettingsFallback;
